import { storeToRefs } from "pinia"
import { useProjectStore } from "@/store/projects.store"
import { type Project } from "@/models/project.model"
import { createRule, type Maybe } from "@regle/core"

function isUniqueNameAndExecutor(value: Maybe<string>, project: Project) {
  if (!value || !project.name || !project.executor) return true
  const projectStore = useProjectStore()
  const { projects } = storeToRefs(projectStore)

  return !projects.value.some((proj: Project) => {
    return (
      proj.name.toLowerCase() === project.name.toLowerCase() &&
      proj.executor?.id === project.executor?.id &&
      proj.id !== project.id // Exclude the current project from the check
    )
  })
}

export const isUniqueNameAndExecutorValidator = createRule({
  validator: isUniqueNameAndExecutor,
  message: "Er bestaat al een project met deze naam en financieel verantwoordelijke"
})
